module.exports = __webpack_public_path__ + "img/note-added.b3229808.svg";